/**
 * SIEM shared utilities
 * For Media Devoted | Created By Ciro Autiero
 */

import type { SiemLevel } from '@/hooks';

export function formatDateTime(value: string): string {
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value));
}

export function levelTone(level: SiemLevel): { badge: string; text: string } {
  if (level === 'critical')
    return { badge: 'bg-destructive/10 text-destructive border-destructive/20', text: 'CRITICAL' };
  if (level === 'error')
    return { badge: 'bg-destructive/10 text-destructive border-destructive/20', text: 'ERROR' };
  if (level === 'warn')
    return { badge: 'bg-warning/10 text-warning border-warning/20', text: 'WARN' };
  if (level === 'info')
    return { badge: 'bg-info/10 text-info border-info/20', text: 'INFO' };
  return { badge: 'bg-muted text-muted-foreground border-border', text: 'DEBUG' };
}

export function toIsoFromLocalInput(value: string): string | undefined {
  const raw = (value || '').trim();
  if (!raw) return undefined;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();
}

/** Format Date for datetime-local input (YYYY-MM-DDTHH:mm) */
export function toDatetimeLocal(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
